import React from "react";
import { RouteProps } from "react-router-dom";
import { routeConstants } from "@/shared/constants";
import loadable from "@/shared/utils/loadable";

const Route = loadable(import("./index"));

const HistoryRoute: RouteProps = {
  path: routeConstants.history.route,
  element: React.createElement(Route),
};

export default HistoryRoute;
